<agpr-dialog-container
    *ngIf="!hide"
    [id]="'distributionConfirmationDialog'"
    [contentPadding]="false"
    (close)="closeDialog()"
    [heading]="'Discover.distribution.confirmation.heading'"
>
    <div class="agpr-distributionConfirmationDialog" [agprLoading]="loading">
        <agpr-scroll-panel>
            <div class="agpr-distributionConfirmationDialog-header">
                <span class="agpr-distributionConfirmationDialog-headerIcon fa-kit-duotone fa-agpr-distribution" aria-hidden="true"></span>
                <div class="agpr-distributionConfirmationDialog-headerText">
                    <p class="agpr-distributionConfirmationDialog-headerMainText">{{ 'Discover.distribution.confirmation.headerMainText' | localize }}</p>
                    <p class="agpr-distributionConfirmationDialog-headerSubText">{{ 'Discover.distribution.confirmation.headerSubText' | localize }}</p>
                </div>
            </div>

            <div class="agpr-distributionConfirmationDialog-disclaimer">
                <agpr-checkbox
                    id="disclaimerCheckbox"
                    [label]="'Discover.distribution.confirmation.disclaimer' | localize: {deliveryTime:deliveryTime}"
                    [value]="disclaimerApproved"
                    (onChange)="disclaimerApproved = !disclaimerApproved"
                ></agpr-checkbox>
            </div>
        </agpr-scroll-panel>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            id="cancelButton"
            [label]="'Core.button.cancel'"
            [style]="buttonTypes.secondary"
            (click)="closeDialog()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            id="confirmationButton"
            [label]="'Discover.distribution.confirmation.confirmAndSend'"
            [disabled]="!disclaimerApproved || loading"
            [style]="buttonTypes.primary"
            (click)="sendDistribution()"
        ></agpr-button>
    </ng-template>

</agpr-dialog-container>
